import { Grid, makeStyles } from '@material-ui/core'
import NeedsAttentionReason from 'components/common/NeedsAttentionReason'
import DazzedHeadingForGrid from 'components/common/text/DazzedHeadingForGrid'
import React from 'react'

const useStyles = makeStyles(theme => ({
  reasonCount: {
    padding: '0 5px',
    color: ({ selected }) => (selected ? '#FFFFFF' : '#001335')
  }
}))

const ReasonWithCount = ({ containerClassName, reason, count = 0, onReasonClicked, selected = false }) => {
  const classes = useStyles({ isTransparent: count === 0, selected })

  return (
    <Grid
      item
      className={containerClassName}
      style={{
        opacity: count === 0 ? 0.4 : 1,
        backgroundColor: selected ? '#7586FF' : count === 0 ? '#F6F6F6' : '#E7EAFF',
        color: selected ? '#FFFFFF' : '#001335',
        pointerEvents: count === 0 ? 'none' : 'auto',
        border: selected ? '2px solid #3C52EF' : 'none'
      }}
      onClick={() => onReasonClicked(reason)}
    >
      <NeedsAttentionReason reason={reason} shortened withElipsis={false} color={selected ? '#FFFFFF' : '#001335'} />
      {count > 0 && (
        <DazzedHeadingForGrid className={classes.reasonCount} xs={14}>
          {count}
        </DazzedHeadingForGrid>
      )}
    </Grid>
  )
}

export default ReasonWithCount
